import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

export default function Activities({ activities, colors }) {
  if (!activities || activities.length === 0) return null;

  return (
    <Box
      sx={{
        mt: 4,
        ml: "32px",
        p: 3,
        borderRadius: 2,
        backgroundColor: colors.primary[400],
        width: "calc(100% - 32px)",
        // boxShadow: 2,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          color: colors.grey[100],
          borderBottom: `1px solid ${colors.grey[700]}`,
          pb: 0.5,
        }}
      >
        Activities
      </Typography>

      <Grid container spacing={2}>
        {activities.map((activity, index) => (
          <Grid item xs={12} md={6} key={activity.id || index}>
            <Stack
              p={1.5}
              borderRadius={2}
              border={1}
              borderColor={colors.greenAccent[600]}
              bgcolor={colors.primary[500]}
              spacing={1}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontWeight={600} color={colors.greenAccent[400]}>
                  {activity?.name || "N/A"}
                </Typography>
                {/* <Typography variant="body2" color={colors.grey[300]}>
                  ₹{(activity?.rate || 0)}
                </Typography> */}
              </Stack>

              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color={colors.grey[200]}>
                  Rate: ₹{activity?.rate || 0}
                </Typography>
                <Typography variant="body2" color={colors.grey[200]}>
                  Qty: {activity?.count || 0}
                </Typography>
              </Stack>

              {activity?.description && (
                <Typography
                  variant="body2"
                  color={colors.grey[400]}
                  sx={{ fontStyle: "italic" }}
                >
                  {activity.description}
                </Typography>
              )}
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
